import { strEnum } from "../../types";

export interface ITCIAsrContext {
    serviceId: string;
    gsbc?: string;
    org?: string;
    path?: string;
    operation?: string;
    subId?: string;
}

export interface ITCIAsrConfig {
    modalConfig: {
        validateRuntime: TCI_WS_ASR_VALIDATE_RUNTIME,
        validateApiSpec: TCI_WS_ASR_VALIDATE_API_SPEC,
        validateOperation: TCI_WS_ASR_VALIDATE_OPERATION,
        onSelection: Function,
        crossOrgSharing: boolean,
        globalIntercom: boolean
        context?: ITCIAsrContext;
    };
    openAsrModal: Function;
}

/**
 * validateRuntime
 * Return "null" for validation pass
 *
 * validateRuntime: (extAuthz, intercom, assurance) => {
 *  if (intercom)
 *    return null;
 *  else
 *    return "TIBCO Cloud XYZ does not support this kind of service.";
 *  }
 */
export type TCI_WS_ASR_VALIDATE_RUNTIME = (extAuthz: string[], intercom: boolean, assurance: string) => string;
/**
 * validateApiSpec
 * Return "null" for validation pass
 * First argument is Swagger Schema
 *
 * apiSpec is the entire Swagger
 * Typical error use-cases:
 * 1. the apiSpec is OpenAPI 3.0, but you only support Swagger 2.0
 * 2. You require some extension field (e.g. "x-tcla-magic") and it is absent
 * Return a string (or a non-empty list of strings) to signal error.
 *
 * if (apiSpec.swagger === "2.0" || apiSpec.openapi === "3.0.0")
 *   return null;
 * else
 *   return "TIBCO Cloud XYZ does not support this kind of service.";
 */
export type TCI_WS_ASR_VALIDATE_API_SPEC = (apiSpec: any) => string;
/**
 * validateOperation
 * Return "null" for validation pass
 * First argument is Swagger Schema
 *
 * apiSpec is the entire Swagger
 * path is e.g. "/pet/{petId}"
 * operation is e.g. "get"
 * The operation details can be accessed as apiSpec[path][operation]
 * Return an error string (or an array of strings) if you cannot support the method or signature of the operation,
 * or if you require some optional field that is missing (e.g. "operationId")
 *
 * const op = apiSpec.paths[path][operation];
 * if (op.operationId)
 *   return null;
 * else
 *   return "This operation has no operationId." // I believe this is the use-case for TCLA
 */
export const TCI_WS_ASR_VALIDATE_OPERATION_TYPES = strEnum(["get", "post", "put", "delete"]);
export type TCI_WS_ASR_VALIDATE_OPERATION_TYPES = keyof typeof TCI_WS_ASR_VALIDATE_OPERATION_TYPES;
export type TCI_WS_ASR_VALIDATE_OPERATION =
    (apiSpec: any, path: string, operation: TCI_WS_ASR_VALIDATE_OPERATION_TYPES) => string;

/**
 * Catalog of validation functions
 */
export const TCI_WS_ASR_VALIDATE_FUNCTIONS = strEnum(["runtime", "spec", "operation"]);
export type TCI_WS_ASR_VALIDATE_FUNCTIONS = keyof typeof TCI_WS_ASR_VALIDATE_OPERATION_TYPES;

/**
 * ASR Model Schema
 */
export interface ITCIASRModelSchema {
    gsbc: string;
    operation: string;
    path: string;
    service: {
        apiSpec?: any; // A Swagger object
        assurance?: string; // TODO: Create enum
        baseURL?: string;
        description?: string;
        extAuthz?: string[];
        intercom?: boolean;
        intercomRegion?: string;
        path?: string;
        serviceId: string; // This is required
        swaggerChecksum?: string;
        title?: string;
    };
}

// Close events catalog
export const ASR_CLOSE_EVENTS = ["closeModalWithOutSelect", "closeModal"];
